
const getters = {
	isLogin: state => state.user.isLogin,
	userInfo: state => state.user.userInfo,
	role: state => state.user.role,
	token: state => state.user.token,
	is_check: state => state.user.is_check,
	is_vip: state => state.user.is_vip,
	user_count: state => state.user.user_count,
	userStatisticsLoading: state => state.user.userStatisticsLoading,
	config: state => state.config.config,
	settlement_list: state => state.order.list,
	user_message_count: state => state.user.user_message_count,
}

export default getters